export const cfcVsBfcContestListByCategory = [
  {
    _id: '631301f38977f2001ed3422e',
    contests: [
      {
        _id: '63d11ad38d8436001e1bed5b',
        createdOn: '2022-10-08T06:32:47.030Z',
        deletedOn: null,
        contestTypeId: '628747cdc76dd0419be8e2cb',
        contestCategoryId: '631301f38977f2001ed3422e',
        tenant: 'dev',
        title: 'H2H 20',
        description: 'Head To Head',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 3500,
        entryFee: 2000,
        winningsPerPosition: {
          '3500': 1
        },
        selfReplicating: true,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 500,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        matchId: '63cc159c6bc8d3ddb98f5cf6',
        isCanceled: false,
        status: 1,
        statusText: 'scheduled',
        gameState: 0,
        gameStateText: 'None',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 1
      },
      {
        _id: '63d11ad38d8436001e1bed5d',
        createdOn: '2022-10-08T06:31:30.892Z',
        deletedOn: null,
        contestTypeId: '628747cdc76dd0419be8e2cb',
        contestCategoryId: '631301f38977f2001ed3422e',
        tenant: 'dev',
        title: 'H2H 5',
        description: 'Head to head',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 900,
        entryFee: 500,
        winningsPerPosition: {
          '900': 1
        },
        selfReplicating: true,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 100,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        matchId: '63cc159c6bc8d3ddb98f5cf6',
        isCanceled: false,
        status: 1,
        statusText: 'scheduled',
        gameState: 0,
        gameStateText: 'None',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0
      },
      {
        _id: '63d11ac68d8436001e1bed57',
        createdOn: '2022-10-08T06:34:49.031Z',
        deletedOn: null,
        contestTypeId: '628747cdc76dd0419be8e2cb',
        contestCategoryId: '631301f38977f2001ed3422e',
        tenant: 'dev',
        title: 'H2H 50',
        description: 'Head To Head',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 9000,
        entryFee: 5000,
        winningsPerPosition: {
          '9000': 1
        },
        selfReplicating: true,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 1000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        matchId: '63cc159c6bc8d3ddb98f5cf6',
        isCanceled: false,
        status: 1,
        statusText: 'upcoming',
        gameState: 1,
        gameStateText: 'Not started',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        modifiedOn: '2023-01-25T12:04:00.322Z',
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d11ac68d8436001e1bed55',
        createdOn: '2022-10-08T06:32:47.030Z',
        deletedOn: null,
        contestTypeId: '628747cdc76dd0419be8e2cb',
        contestCategoryId: '631301f38977f2001ed3422e',
        tenant: 'dev',
        title: 'H2H 20',
        description: 'Head To Head',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 3500,
        entryFee: 2000,
        winningsPerPosition: {
          '3500': 1
        },
        selfReplicating: true,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 500,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        matchId: '63cc159c6bc8d3ddb98f5cf6',
        isCanceled: false,
        status: 1,
        statusText: 'upcoming',
        gameState: 1,
        gameStateText: 'Not started',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        modifiedOn: '2023-01-25T12:04:00.322Z',
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d11ac68d8436001e1bed59',
        createdOn: '2022-10-08T06:31:30.892Z',
        deletedOn: null,
        contestTypeId: '628747cdc76dd0419be8e2cb',
        contestCategoryId: '631301f38977f2001ed3422e',
        tenant: 'dev',
        title: 'H2H 5',
        description: 'Head to head',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 900,
        entryFee: 500,
        winningsPerPosition: {
          '900': 1
        },
        selfReplicating: true,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 100,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        matchId: '63cc159c6bc8d3ddb98f5cf6',
        isCanceled: false,
        status: 1,
        statusText: 'upcoming',
        gameState: 1,
        gameStateText: 'Not started',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        modifiedOn: '2023-01-25T12:04:00.322Z',
        states: {
          '1': true
        },
        verified: false
      }
    ]
  }
];

export const jfcVsMcfMyContestListByCategory = [
  {
    _id: '631301f38977f2001ed3422e',
    contests: [
      {
        _id: '63d33d508d8436001e1bedaa',
        createdOn: '2022-10-08T06:34:49.031Z',
        deletedOn: null,
        contestTypeId: '628747cdc76dd0419be8e2cb',
        contestCategoryId: '631301f38977f2001ed3422e',
        tenant: 'dev',
        title: 'H2H 50',
        description: 'Head To Head',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 9000,
        entryFee: 5000,
        winningsPerPosition: {
          '9000': 1
        },
        selfReplicating: true,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 1000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        matchId: '63cb03286bc8d3ddb965e21b',
        isCanceled: false,
        status: 1,
        statusText: 'upcoming',
        gameState: 1,
        gameStateText: 'Not started',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        modifiedOn: '2023-01-27T03:00:00.339Z',
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d33d508d8436001e1bedb2',
        createdOn: '2022-10-08T06:31:30.892Z',
        deletedOn: null,
        contestTypeId: '628747cdc76dd0419be8e2cb',
        contestCategoryId: '631301f38977f2001ed3422e',
        tenant: 'dev',
        title: 'H2H 5',
        description: 'Head to head',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 900,
        entryFee: 500,
        winningsPerPosition: {
          '900': 1
        },
        selfReplicating: true,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 100,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        matchId: '63cb03286bc8d3ddb965e21b',
        isCanceled: false,
        status: 1,
        statusText: 'upcoming',
        gameState: 1,
        gameStateText: 'Not started',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 1,
        modifiedOn: '2023-01-27T03:00:00.339Z',
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d33d508d8436001e1bedb4',
        createdOn: '2022-10-08T06:32:47.030Z',
        deletedOn: null,
        contestTypeId: '628747cdc76dd0419be8e2cb',
        contestCategoryId: '631301f38977f2001ed3422e',
        tenant: 'dev',
        title: 'H2H 20',
        description: 'Head To Head',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 3500,
        entryFee: 2000,
        winningsPerPosition: {
          '3500': 1
        },
        selfReplicating: true,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 500,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        matchId: '63cb03286bc8d3ddb965e21b',
        isCanceled: false,
        status: 1,
        statusText: 'upcoming',
        gameState: 1,
        gameStateText: 'Not started',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        modifiedOn: '2023-01-27T03:00:00.339Z',
        states: {
          '1': true
        },
        verified: false
      }
    ]
  },
  {
    _id: '61817f8fb2569b001f9ddedd',
    contests: [
      {
        _id: '63d33d508d8436001e1bedb0',
        createdOn: '2023-01-27T02:51:54.145Z',
        deletedOn: null,
        contestTypeId: '628747cdc76dd0419be8e2cd',
        contestCategoryId: '61817f8fb2569b001f9ddedd',
        tenant: 'dev',
        title: 'mult2',
        description: 'mult2',
        minimumPlayers: 2,
        maximumPlayers: 10,
        maxTeamPerUser: 1,
        winningsAmount: 500000,
        entryFee: 300000,
        winningsPerPosition: {
          '500000': 1
        },
        selfReplicating: true,
        bonusPercentage: 10,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 200,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        matchId: '63cb03286bc8d3ddb965e21b',
        isCanceled: false,
        status: 1,
        statusText: 'upcoming',
        gameState: 1,
        gameStateText: 'Not started',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        modifiedOn: '2023-01-27T03:00:00.339Z',
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d33d508d8436001e1bedac',
        createdOn: '2022-10-08T06:51:23.993Z',
        deletedOn: null,
        contestTypeId: '628747cdc76dd0419be8e2cd',
        contestCategoryId: '61817f8fb2569b001f9ddedd',
        tenant: 'dev',
        title: 'giveaway',
        description: 'giveaway',
        minimumPlayers: 100000,
        maximumPlayers: 100000,
        maxTeamPerUser: 11,
        winningsAmount: 5000000,
        entryFee: 0,
        winningsPerPosition: {
          '1100': 1000,
          '30000': 50,
          '40000': 10,
          '50000': 10,
          '100000': 1,
          '200000': 1,
          '300000': 1,
          '400000': 1,
          '500000': 1
        },
        selfReplicating: false,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 0,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        matchId: '63cb03286bc8d3ddb965e21b',
        isCanceled: false,
        status: 1,
        statusText: 'upcoming',
        gameState: 1,
        gameStateText: 'Not started',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        modifiedOn: '2023-01-27T03:00:00.339Z',
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d33d508d8436001e1bedae',
        createdOn: '2023-01-27T02:51:17.978Z',
        deletedOn: null,
        contestTypeId: '628747cdc76dd0419be8e2cd',
        contestCategoryId: '61817f8fb2569b001f9ddedd',
        tenant: 'dev',
        title: 'multiple',
        description: 'multiple',
        minimumPlayers: 2,
        maximumPlayers: 10,
        maxTeamPerUser: 1,
        winningsAmount: 500000,
        entryFee: 300000,
        winningsPerPosition: {
          '500000': 1
        },
        selfReplicating: true,
        bonusPercentage: 10,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 300,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        matchId: '63cb03286bc8d3ddb965e21b',
        isCanceled: false,
        status: 1,
        statusText: 'upcoming',
        gameState: 1,
        gameStateText: 'Not started',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        modifiedOn: '2023-01-27T03:00:00.339Z',
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d33d508d8436001e1bedb6',
        createdOn: '2022-10-08T06:48:15.874Z',
        deletedOn: null,
        contestTypeId: '628747cdc76dd0419be8e2cd',
        contestCategoryId: '61817f8fb2569b001f9ddedd',
        tenant: 'dev',
        title: 'GL 25K',
        description: 'GL',
        minimumPlayers: 1000,
        maximumPlayers: 1000,
        maxTeamPerUser: 11,
        winningsAmount: 2500000,
        entryFee: 3000,
        winningsPerPosition: {
          '9000': 100,
          '30000': 20,
          '40000': 5,
          '50000': 2,
          '100000': 1,
          '200000': 1,
          '400000': 1
        },
        selfReplicating: false,
        bonusPercentage: 0,
        isConfirmed: true,
        isDynamicWinnings: false,
        adminFees: 500000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        matchId: '63cb03286bc8d3ddb965e21b',
        isCanceled: false,
        status: 1,
        statusText: 'upcoming',
        gameState: 1,
        gameStateText: 'Not started',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        modifiedOn: '2023-01-27T03:00:00.339Z',
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d33d508d8436001e1beda8',
        createdOn: '2023-01-27T02:52:42.023Z',
        deletedOn: null,
        contestTypeId: '628747cdc76dd0419be8e2cd',
        contestCategoryId: '61817f8fb2569b001f9ddedd',
        tenant: 'dev',
        title: 'mult3',
        description: 'mult3',
        minimumPlayers: 2,
        maximumPlayers: 10,
        maxTeamPerUser: 1,
        winningsAmount: 150000,
        entryFee: 100000,
        winningsPerPosition: {
          '150000': 1
        },
        selfReplicating: true,
        bonusPercentage: 10,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 300,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        matchId: '63cb03286bc8d3ddb965e21b',
        isCanceled: false,
        status: 1,
        statusText: 'upcoming',
        gameState: 1,
        gameStateText: 'Not started',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        modifiedOn: '2023-01-27T03:00:00.339Z',
        states: {
          '1': true
        },
        verified: false
      }
    ]
  }
];
export const kerVsNorContestListByCategory = [
  {
    _id: '61821e0cb2569b001f9ddf50',
    contests: [
      {
        _id: '63d35b078d8436001e1bedf8',
        createdOn: '2023-01-27T04:57:41.157Z',
        deletedOn: null,
        contestTypeId: '628747cdc76dd0419be8e2cd',
        contestCategoryId: '61821e0cb2569b001f9ddf50',
        tenant: 'dev',
        title: 'Win More1',
        description: 'Win More',
        minimumPlayers: 100,
        maximumPlayers: 150,
        maxTeamPerUser: 8,
        winningsAmount: 10000,
        entryFee: 100,
        winningsPerPosition: {
          '3000': 1,
          '7000': 1
        },
        selfReplicating: true,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 100,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        matchId: '63d29ad46bc8d3ddb9782e01',
        isCanceled: false,
        status: 1,
        statusText: 'upcoming',
        gameState: 1,
        gameStateText: 'Not started',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 2,
        modifiedOn: '2023-01-27T12:10:00.516Z',
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d35b078d8436001e1bedfa',
        createdOn: '2022-10-08T06:51:23.993Z',
        deletedOn: null,
        contestTypeId: '628747cdc76dd0419be8e2cd',
        contestCategoryId: '61821e0cb2569b001f9ddf50',
        tenant: 'dev',
        title: 'Win More4',
        description: 'Win More',
        minimumPlayers: 100000,
        maximumPlayers: 100000,
        maxTeamPerUser: 11,
        winningsAmount: 5000000,
        entryFee: 0,
        winningsPerPosition: {
          '1100': 1000,
          '30000': 50,
          '40000': 10,
          '50000': 10,
          '100000': 1,
          '200000': 1,
          '300000': 1,
          '400000': 1,
          '500000': 1
        },
        selfReplicating: false,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 0,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        matchId: '63d29ad46bc8d3ddb9782e01',
        isCanceled: false,
        status: 1,
        statusText: 'upcoming',
        gameState: 1,
        gameStateText: 'Not started',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        modifiedOn: '2023-01-27T12:10:00.516Z',
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d35b078d8436001e1bedfc',
        createdOn: '2023-01-27T02:51:17.978Z',
        deletedOn: null,
        contestTypeId: '628747cdc76dd0419be8e2cd',
        contestCategoryId: '61821e0cb2569b001f9ddf50',
        tenant: 'dev',
        title: 'Win More3',
        description: 'Win More',
        minimumPlayers: 2,
        maximumPlayers: 10,
        maxTeamPerUser: 1,
        winningsAmount: 500000,
        entryFee: 300000,
        winningsPerPosition: {
          '500000': 1
        },
        selfReplicating: false,
        bonusPercentage: 10,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 300,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        matchId: '63d29ad46bc8d3ddb9782e01',
        isCanceled: false,
        status: 1,
        statusText: 'upcoming',
        gameState: 1,
        gameStateText: 'Not started',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        modifiedOn: '2023-01-27T12:10:00.516Z',
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d35b0f8d8436001e1bedfe',
        createdOn: '2023-01-27T04:57:41.157Z',
        deletedOn: null,
        contestTypeId: '628747cdc76dd0419be8e2cd',
        contestCategoryId: '61821e0cb2569b001f9ddf50',
        tenant: 'dev',
        title: 'Win More1',
        description: 'Win More',
        minimumPlayers: 100,
        maximumPlayers: 150,
        maxTeamPerUser: 8,
        winningsAmount: 10000,
        entryFee: 100,
        winningsPerPosition: {
          '3000': 1,
          '7000': 1
        },
        selfReplicating: true,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 100,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        matchId: '63d29ad46bc8d3ddb9782e01',
        isCanceled: false,
        status: 1,
        statusText: 'upcoming',
        gameState: 1,
        gameStateText: 'Not started',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        modifiedOn: '2023-01-27T12:10:00.516Z',
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d35b0f8d8436001e1bee00',
        createdOn: '2022-10-08T06:51:23.993Z',
        deletedOn: null,
        contestTypeId: '628747cdc76dd0419be8e2cd',
        contestCategoryId: '61821e0cb2569b001f9ddf50',
        tenant: 'dev',
        title: 'Win More4',
        description: 'Win More',
        minimumPlayers: 100000,
        maximumPlayers: 100000,
        maxTeamPerUser: 11,
        winningsAmount: 5000000,
        entryFee: 0,
        winningsPerPosition: {
          '1100': 1000,
          '30000': 50,
          '40000': 10,
          '50000': 10,
          '100000': 1,
          '200000': 1,
          '300000': 1,
          '400000': 1,
          '500000': 1
        },
        selfReplicating: false,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 0,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        matchId: '63d29ad46bc8d3ddb9782e01',
        isCanceled: false,
        status: 1,
        statusText: 'upcoming',
        gameState: 1,
        gameStateText: 'Not started',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        modifiedOn: '2023-01-27T12:10:00.516Z',
        states: {
          '1': true
        },
        verified: false
      }
    ]
  },
  {
    _id: '631301f38977f2001ed3422e',
    contests: [
      {
        _id: '63d339f18d8436001e1bed66',
        createdOn: '2022-10-08T06:34:49.031Z',
        deletedOn: null,
        contestTypeId: '628747cdc76dd0419be8e2cb',
        contestCategoryId: '631301f38977f2001ed3422e',
        tenant: 'dev',
        title: 'H2H 50',
        description: 'Head To Head',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 9000,
        entryFee: 5000,
        winningsPerPosition: {
          '9000': 1
        },
        selfReplicating: true,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 1000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        matchId: '63d29ad46bc8d3ddb9782e01',
        isCanceled: false,
        status: 1,
        statusText: 'upcoming',
        gameState: 1,
        gameStateText: 'Not started',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        modifiedOn: '2023-01-27T12:10:00.516Z',
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d339f18d8436001e1bed64',
        createdOn: '2022-10-08T06:32:47.030Z',
        deletedOn: null,
        contestTypeId: '628747cdc76dd0419be8e2cb',
        contestCategoryId: '631301f38977f2001ed3422e',
        tenant: 'dev',
        title: 'H2H 20',
        description: 'Head To Head',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 3500,
        entryFee: 2000,
        winningsPerPosition: {
          '3500': 1
        },
        selfReplicating: true,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 500,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        matchId: '63d29ad46bc8d3ddb9782e01',
        isCanceled: false,
        status: 1,
        statusText: 'upcoming',
        gameState: 1,
        gameStateText: 'Not started',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        modifiedOn: '2023-01-27T12:10:00.516Z',
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d339f18d8436001e1bed6a',
        createdOn: '2022-10-08T06:31:30.892Z',
        deletedOn: null,
        contestTypeId: '628747cdc76dd0419be8e2cb',
        contestCategoryId: '631301f38977f2001ed3422e',
        tenant: 'dev',
        title: 'H2H 5',
        description: 'Head to head',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 900,
        entryFee: 500,
        winningsPerPosition: {
          '900': 1
        },
        selfReplicating: true,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 100,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        matchId: '63d29ad46bc8d3ddb9782e01',
        isCanceled: false,
        status: 1,
        statusText: 'upcoming',
        gameState: 1,
        gameStateText: 'Not started',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        modifiedOn: '2023-01-27T12:10:00.516Z',
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d339fc8d8436001e1bed6e',
        createdOn: '2022-10-08T06:32:47.030Z',
        deletedOn: null,
        contestTypeId: '628747cdc76dd0419be8e2cb',
        contestCategoryId: '631301f38977f2001ed3422e',
        tenant: 'dev',
        title: 'H2H 20',
        description: 'Head To Head',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 3500,
        entryFee: 2000,
        winningsPerPosition: {
          '3500': 1
        },
        selfReplicating: true,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 500,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        matchId: '63d29ad46bc8d3ddb9782e01',
        isCanceled: false,
        status: 1,
        statusText: 'upcoming',
        gameState: 1,
        gameStateText: 'Not started',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        modifiedOn: '2023-01-27T12:10:00.516Z',
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d339fc8d8436001e1bed6c',
        createdOn: '2022-10-08T06:34:49.031Z',
        deletedOn: null,
        contestTypeId: '628747cdc76dd0419be8e2cb',
        contestCategoryId: '631301f38977f2001ed3422e',
        tenant: 'dev',
        title: 'H2H 50',
        description: 'Head To Head',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 9000,
        entryFee: 5000,
        winningsPerPosition: {
          '9000': 1
        },
        selfReplicating: true,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 1000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        matchId: '63d29ad46bc8d3ddb9782e01',
        isCanceled: false,
        status: 1,
        statusText: 'upcoming',
        gameState: 1,
        gameStateText: 'Not started',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        modifiedOn: '2023-01-27T12:10:00.516Z',
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d339fc8d8436001e1bed70',
        createdOn: '2022-10-08T06:31:30.892Z',
        deletedOn: null,
        contestTypeId: '628747cdc76dd0419be8e2cb',
        contestCategoryId: '631301f38977f2001ed3422e',
        tenant: 'dev',
        title: 'H2H 5',
        description: 'Head to head',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 900,
        entryFee: 500,
        winningsPerPosition: {
          '900': 1
        },
        selfReplicating: true,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 100,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        matchId: '63d29ad46bc8d3ddb9782e01',
        isCanceled: false,
        status: 1,
        statusText: 'upcoming',
        gameState: 1,
        gameStateText: 'Not started',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        modifiedOn: '2023-01-27T12:10:00.516Z',
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d358338d8436001e1bedd0',
        createdOn: '2023-01-27T04:49:16.853Z',
        deletedOn: null,
        contestTypeId: '628747cdc76dd0419be8e2cb',
        contestCategoryId: '631301f38977f2001ed3422e',
        tenant: 'dev',
        title: 'H2H2',
        description: 'H2H',
        minimumPlayers: 2,
        maximumPlayers: 10,
        maxTeamPerUser: 1,
        winningsAmount: 100000,
        entryFee: 70000,
        winningsPerPosition: {
          '100000': 1
        },
        selfReplicating: true,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 1000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        matchId: '63d29ad46bc8d3ddb9782e01',
        isCanceled: false,
        status: 1,
        statusText: 'upcoming',
        gameState: 1,
        gameStateText: 'Not started',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        modifiedOn: '2023-01-27T12:10:00.516Z',
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d358338d8436001e1bedce',
        createdOn: '2023-01-27T04:47:49.705Z',
        deletedOn: null,
        contestTypeId: '628747cdc76dd0419be8e2cb',
        contestCategoryId: '631301f38977f2001ed3422e',
        tenant: 'dev',
        title: 'H2H1',
        description: 'H2H',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 10000,
        entryFee: 7000,
        winningsPerPosition: {
          '10000': 1
        },
        selfReplicating: true,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 100,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        matchId: '63d29ad46bc8d3ddb9782e01',
        isCanceled: false,
        status: 1,
        statusText: 'upcoming',
        gameState: 1,
        gameStateText: 'Not started',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        modifiedOn: '2023-01-27T12:10:00.516Z',
        states: {
          '1': true
        },
        verified: false
      }
    ]
  },
  {
    _id: '61817f8fb2569b001f9ddedd',
    contests: [
      {
        _id: '63d339f18d8436001e1bed68',
        createdOn: '2022-10-08T06:48:15.874Z',
        deletedOn: null,
        contestTypeId: '628747cdc76dd0419be8e2cd',
        contestCategoryId: '61817f8fb2569b001f9ddedd',
        tenant: 'dev',
        title: 'GL 25K',
        description: 'GL',
        minimumPlayers: 1000,
        maximumPlayers: 1000,
        maxTeamPerUser: 11,
        winningsAmount: 2500000,
        entryFee: 3000,
        winningsPerPosition: {
          '9000': 100,
          '30000': 20,
          '40000': 5,
          '50000': 2,
          '100000': 1,
          '200000': 1,
          '400000': 1
        },
        selfReplicating: false,
        bonusPercentage: 0,
        isConfirmed: true,
        isDynamicWinnings: false,
        adminFees: 500000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        matchId: '63d29ad46bc8d3ddb9782e01',
        isCanceled: false,
        status: 1,
        statusText: 'upcoming',
        gameState: 1,
        gameStateText: 'Not started',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        modifiedOn: '2023-01-27T12:10:00.516Z',
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d339fc8d8436001e1bed72',
        createdOn: '2022-10-08T06:48:15.874Z',
        deletedOn: null,
        contestTypeId: '628747cdc76dd0419be8e2cd',
        contestCategoryId: '61817f8fb2569b001f9ddedd',
        tenant: 'dev',
        title: 'GL 25K',
        description: 'GL',
        minimumPlayers: 1000,
        maximumPlayers: 1000,
        maxTeamPerUser: 11,
        winningsAmount: 2500000,
        entryFee: 3000,
        winningsPerPosition: {
          '9000': 100,
          '30000': 20,
          '40000': 5,
          '50000': 2,
          '100000': 1,
          '200000': 1,
          '400000': 1
        },
        selfReplicating: false,
        bonusPercentage: 0,
        isConfirmed: true,
        isDynamicWinnings: false,
        adminFees: 500000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        matchId: '63d29ad46bc8d3ddb9782e01',
        isCanceled: false,
        status: 1,
        statusText: 'upcoming',
        gameState: 1,
        gameStateText: 'Not started',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        modifiedOn: '2023-01-27T12:10:00.516Z',
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d33b558d8436001e1bed78',
        createdOn: '2023-01-27T02:47:49.187Z',
        deletedOn: null,
        contestTypeId: '628747cdc76dd0419be8e2cd',
        contestCategoryId: '61817f8fb2569b001f9ddedd',
        tenant: 'dev',
        title: 'multi',
        description: 'multi',
        minimumPlayers: 2,
        maximumPlayers: 10,
        maxTeamPerUser: 10,
        winningsAmount: 200000,
        entryFee: 150000,
        winningsPerPosition: {
          '200000': 1
        },
        selfReplicating: true,
        bonusPercentage: 10,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 300,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        matchId: '63d29ad46bc8d3ddb9782e01',
        isCanceled: false,
        status: 1,
        statusText: 'upcoming',
        gameState: 1,
        gameStateText: 'Not started',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        modifiedOn: '2023-01-27T12:10:00.516Z',
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d33b858d8436001e1bed7a',
        createdOn: '2022-10-08T06:48:15.874Z',
        deletedOn: null,
        contestTypeId: '628747cdc76dd0419be8e2cd',
        contestCategoryId: '61817f8fb2569b001f9ddedd',
        tenant: 'dev',
        title: 'GL 25K',
        description: 'GL',
        minimumPlayers: 1000,
        maximumPlayers: 1000,
        maxTeamPerUser: 11,
        winningsAmount: 2500000,
        entryFee: 3000,
        winningsPerPosition: {
          '9000': 100,
          '30000': 20,
          '40000': 5,
          '50000': 2,
          '100000': 1,
          '200000': 1,
          '400000': 1
        },
        selfReplicating: false,
        bonusPercentage: 0,
        isConfirmed: true,
        isDynamicWinnings: false,
        adminFees: 500000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        matchId: '63d29ad46bc8d3ddb9782e01',
        isCanceled: false,
        status: 1,
        statusText: 'upcoming',
        gameState: 1,
        gameStateText: 'Not started',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        modifiedOn: '2023-01-27T12:10:00.516Z',
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d33b938d8436001e1bed7c',
        createdOn: '2022-10-08T06:48:15.874Z',
        deletedOn: null,
        contestTypeId: '628747cdc76dd0419be8e2cd',
        contestCategoryId: '61817f8fb2569b001f9ddedd',
        tenant: 'dev',
        title: 'GL 25K',
        description: 'GL',
        minimumPlayers: 1000,
        maximumPlayers: 1000,
        maxTeamPerUser: 11,
        winningsAmount: 2500000,
        entryFee: 3000,
        winningsPerPosition: {
          '9000': 100,
          '30000': 20,
          '40000': 5,
          '50000': 2,
          '100000': 1,
          '200000': 1,
          '400000': 1
        },
        selfReplicating: false,
        bonusPercentage: 0,
        isConfirmed: true,
        isDynamicWinnings: false,
        adminFees: 500000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        matchId: '63d29ad46bc8d3ddb9782e01',
        isCanceled: false,
        status: 1,
        statusText: 'upcoming',
        gameState: 1,
        gameStateText: 'Not started',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        modifiedOn: '2023-01-27T12:10:00.516Z',
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d33d038d8436001e1bed86',
        createdOn: '2023-01-27T02:51:17.978Z',
        deletedOn: null,
        contestTypeId: '628747cdc76dd0419be8e2cd',
        contestCategoryId: '61817f8fb2569b001f9ddedd',
        tenant: 'dev',
        title: 'multiple',
        description: 'multiple',
        minimumPlayers: 2,
        maximumPlayers: 10,
        maxTeamPerUser: 1,
        winningsAmount: 500000,
        entryFee: 300000,
        winningsPerPosition: {
          '500000': 1
        },
        selfReplicating: true,
        bonusPercentage: 10,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 300,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        matchId: '63d29ad46bc8d3ddb9782e01',
        isCanceled: false,
        status: 1,
        statusText: 'upcoming',
        gameState: 1,
        gameStateText: 'Not started',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        modifiedOn: '2023-01-27T12:10:00.516Z',
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d33d038d8436001e1bed88',
        createdOn: '2023-01-27T02:52:42.023Z',
        deletedOn: null,
        contestTypeId: '628747cdc76dd0419be8e2cd',
        contestCategoryId: '61817f8fb2569b001f9ddedd',
        tenant: 'dev',
        title: 'mult3',
        description: 'mult3',
        minimumPlayers: 2,
        maximumPlayers: 10,
        maxTeamPerUser: 1,
        winningsAmount: 150000,
        entryFee: 100000,
        winningsPerPosition: {
          '150000': 1
        },
        selfReplicating: true,
        bonusPercentage: 10,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 300,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        matchId: '63d29ad46bc8d3ddb9782e01',
        isCanceled: false,
        status: 1,
        statusText: 'upcoming',
        gameState: 1,
        gameStateText: 'Not started',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        modifiedOn: '2023-01-27T12:10:00.516Z',
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d33d038d8436001e1bed8a',
        createdOn: '2023-01-27T02:51:54.145Z',
        deletedOn: null,
        contestTypeId: '628747cdc76dd0419be8e2cd',
        contestCategoryId: '61817f8fb2569b001f9ddedd',
        tenant: 'dev',
        title: 'mult2',
        description: 'mult2',
        minimumPlayers: 2,
        maximumPlayers: 10,
        maxTeamPerUser: 1,
        winningsAmount: 500000,
        entryFee: 300000,
        winningsPerPosition: {
          '500000': 1
        },
        selfReplicating: true,
        bonusPercentage: 10,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 200,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        matchId: '63d29ad46bc8d3ddb9782e01',
        isCanceled: false,
        status: 1,
        statusText: 'upcoming',
        gameState: 1,
        gameStateText: 'Not started',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        modifiedOn: '2023-01-27T12:10:00.516Z',
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d33d038d8436001e1bed8c',
        createdOn: '2022-10-08T06:51:23.993Z',
        deletedOn: null,
        contestTypeId: '628747cdc76dd0419be8e2cd',
        contestCategoryId: '61817f8fb2569b001f9ddedd',
        tenant: 'dev',
        title: 'giveaway',
        description: 'giveaway',
        minimumPlayers: 100000,
        maximumPlayers: 100000,
        maxTeamPerUser: 11,
        winningsAmount: 5000000,
        entryFee: 0,
        winningsPerPosition: {
          '1100': 1000,
          '30000': 50,
          '40000': 10,
          '50000': 10,
          '100000': 1,
          '200000': 1,
          '300000': 1,
          '400000': 1,
          '500000': 1
        },
        selfReplicating: false,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 0,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        matchId: '63d29ad46bc8d3ddb9782e01',
        isCanceled: false,
        status: 1,
        statusText: 'upcoming',
        gameState: 1,
        gameStateText: 'Not started',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        modifiedOn: '2023-01-27T12:10:00.516Z',
        states: {
          '1': true
        },
        verified: false
      }
    ]
  }
];
export const atkVsOdiContestListByCategory = [
  {
    _id: '631301f38977f2001ed3422e',
    contests: [
      {
        _id: '63d33d208d8436001e1bed98',
        createdOn: '2022-10-08T06:34:49.031Z',
        deletedOn: null,
        contestTypeId: '628747cdc76dd0419be8e2cb',
        contestCategoryId: '631301f38977f2001ed3422e',
        tenant: 'dev',
        title: 'H2H 50',
        description: 'Head To Head',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 9000,
        entryFee: 5000,
        winningsPerPosition: {
          '9000': 1
        },
        selfReplicating: true,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 1000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        matchId: '63cda4c06bc8d3ddb9c91f39',
        isCanceled: false,
        status: 1,
        statusText: 'upcoming',
        gameState: 1,
        gameStateText: 'Not started',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        modifiedOn: '2023-01-27T12:17:00.512Z',
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d33d208d8436001e1bed96',
        createdOn: '2022-10-08T06:31:30.892Z',
        deletedOn: null,
        contestTypeId: '628747cdc76dd0419be8e2cb',
        contestCategoryId: '631301f38977f2001ed3422e',
        tenant: 'dev',
        title: 'H2H 5',
        description: 'Head to head',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 900,
        entryFee: 500,
        winningsPerPosition: {
          '900': 1
        },
        selfReplicating: true,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 100,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        matchId: '63cda4c06bc8d3ddb9c91f39',
        isCanceled: false,
        status: 1,
        statusText: 'upcoming',
        gameState: 1,
        gameStateText: 'Not started',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        modifiedOn: '2023-01-27T12:17:00.512Z',
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d33d208d8436001e1bed9c',
        createdOn: '2022-10-08T06:32:47.030Z',
        deletedOn: null,
        contestTypeId: '628747cdc76dd0419be8e2cb',
        contestCategoryId: '631301f38977f2001ed3422e',
        tenant: 'dev',
        title: 'H2H 20',
        description: 'Head To Head',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 3500,
        entryFee: 2000,
        winningsPerPosition: {
          '3500': 1
        },
        selfReplicating: true,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 500,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        matchId: '63cda4c06bc8d3ddb9c91f39',
        isCanceled: false,
        status: 1,
        statusText: 'upcoming',
        gameState: 1,
        gameStateText: 'Not started',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        modifiedOn: '2023-01-27T12:17:00.512Z',
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d33d2b8d8436001e1bed9e',
        createdOn: '2022-10-08T06:31:30.892Z',
        deletedOn: null,
        contestTypeId: '628747cdc76dd0419be8e2cb',
        contestCategoryId: '631301f38977f2001ed3422e',
        tenant: 'dev',
        title: 'H2H 5',
        description: 'Head to head',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 900,
        entryFee: 500,
        winningsPerPosition: {
          '900': 1
        },
        selfReplicating: true,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 100,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        matchId: '63cda4c06bc8d3ddb9c91f39',
        isCanceled: false,
        status: 1,
        statusText: 'upcoming',
        gameState: 1,
        gameStateText: 'Not started',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        modifiedOn: '2023-01-27T12:17:00.512Z',
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d33d2b8d8436001e1beda2',
        createdOn: '2022-10-08T06:34:49.031Z',
        deletedOn: null,
        contestTypeId: '628747cdc76dd0419be8e2cb',
        contestCategoryId: '631301f38977f2001ed3422e',
        tenant: 'dev',
        title: 'H2H 50',
        description: 'Head To Head',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 9000,
        entryFee: 5000,
        winningsPerPosition: {
          '9000': 1
        },
        selfReplicating: true,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 1000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        matchId: '63cda4c06bc8d3ddb9c91f39',
        isCanceled: false,
        status: 1,
        statusText: 'upcoming',
        gameState: 1,
        gameStateText: 'Not started',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        modifiedOn: '2023-01-27T12:17:00.512Z',
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d33d2b8d8436001e1beda6',
        createdOn: '2022-10-08T06:32:47.030Z',
        deletedOn: null,
        contestTypeId: '628747cdc76dd0419be8e2cb',
        contestCategoryId: '631301f38977f2001ed3422e',
        tenant: 'dev',
        title: 'H2H 20',
        description: 'Head To Head',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 3500,
        entryFee: 2000,
        winningsPerPosition: {
          '3500': 1
        },
        selfReplicating: true,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 500,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        matchId: '63cda4c06bc8d3ddb9c91f39',
        isCanceled: false,
        status: 1,
        statusText: 'upcoming',
        gameState: 1,
        gameStateText: 'Not started',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        modifiedOn: '2023-01-27T12:17:00.512Z',
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d3581c8d8436001e1bedca',
        createdOn: '2023-01-27T04:47:49.705Z',
        deletedOn: null,
        contestTypeId: '628747cdc76dd0419be8e2cb',
        contestCategoryId: '631301f38977f2001ed3422e',
        tenant: 'dev',
        title: 'H2H1',
        description: 'H2H',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 10000,
        entryFee: 7000,
        winningsPerPosition: {
          '10000': 1
        },
        selfReplicating: true,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 100,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        matchId: '63cda4c06bc8d3ddb9c91f39',
        isCanceled: false,
        status: 1,
        statusText: 'upcoming',
        gameState: 1,
        gameStateText: 'Not started',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        modifiedOn: '2023-01-27T12:17:00.512Z',
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d3581c8d8436001e1bedcc',
        createdOn: '2023-01-27T04:49:16.853Z',
        deletedOn: null,
        contestTypeId: '628747cdc76dd0419be8e2cb',
        contestCategoryId: '631301f38977f2001ed3422e',
        tenant: 'dev',
        title: 'H2H2',
        description: 'H2H',
        minimumPlayers: 2,
        maximumPlayers: 10,
        maxTeamPerUser: 1,
        winningsAmount: 100000,
        entryFee: 70000,
        winningsPerPosition: {
          '100000': 1
        },
        selfReplicating: true,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 1000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        matchId: '63cda4c06bc8d3ddb9c91f39',
        isCanceled: false,
        status: 1,
        statusText: 'upcoming',
        gameState: 1,
        gameStateText: 'Not started',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        modifiedOn: '2023-01-27T12:17:00.512Z',
        states: {
          '1': true
        },
        verified: false
      }
    ]
  },
  {
    _id: '61817f8fb2569b001f9ddedd',
    contests: [
      {
        _id: '63d33d208d8436001e1bed94',
        createdOn: '2023-01-27T02:51:54.145Z',
        deletedOn: null,
        contestTypeId: '628747cdc76dd0419be8e2cd',
        contestCategoryId: '61817f8fb2569b001f9ddedd',
        tenant: 'dev',
        title: 'mult2',
        description: 'mult2',
        minimumPlayers: 2,
        maximumPlayers: 10,
        maxTeamPerUser: 1,
        winningsAmount: 500000,
        entryFee: 300000,
        winningsPerPosition: {
          '500000': 1
        },
        selfReplicating: true,
        bonusPercentage: 10,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 200,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        matchId: '63cda4c06bc8d3ddb9c91f39',
        isCanceled: false,
        status: 1,
        statusText: 'upcoming',
        gameState: 1,
        gameStateText: 'Not started',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        modifiedOn: '2023-01-27T12:17:00.512Z',
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d33d208d8436001e1bed8e',
        createdOn: '2023-01-27T02:52:42.023Z',
        deletedOn: null,
        contestTypeId: '628747cdc76dd0419be8e2cd',
        contestCategoryId: '61817f8fb2569b001f9ddedd',
        tenant: 'dev',
        title: 'mult3',
        description: 'mult3',
        minimumPlayers: 2,
        maximumPlayers: 10,
        maxTeamPerUser: 1,
        winningsAmount: 150000,
        entryFee: 100000,
        winningsPerPosition: {
          '150000': 1
        },
        selfReplicating: true,
        bonusPercentage: 10,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 300,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        matchId: '63cda4c06bc8d3ddb9c91f39',
        isCanceled: false,
        status: 1,
        statusText: 'upcoming',
        gameState: 1,
        gameStateText: 'Not started',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        modifiedOn: '2023-01-27T12:17:00.512Z',
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d33d208d8436001e1bed9a',
        createdOn: '2022-10-08T06:48:15.874Z',
        deletedOn: null,
        contestTypeId: '628747cdc76dd0419be8e2cd',
        contestCategoryId: '61817f8fb2569b001f9ddedd',
        tenant: 'dev',
        title: 'GL 25K',
        description: 'GL',
        minimumPlayers: 1000,
        maximumPlayers: 1000,
        maxTeamPerUser: 11,
        winningsAmount: 2500000,
        entryFee: 3000,
        winningsPerPosition: {
          '9000': 100,
          '30000': 20,
          '40000': 5,
          '50000': 2,
          '100000': 1,
          '200000': 1,
          '400000': 1
        },
        selfReplicating: false,
        bonusPercentage: 0,
        isConfirmed: true,
        isDynamicWinnings: false,
        adminFees: 500000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        matchId: '63cda4c06bc8d3ddb9c91f39',
        isCanceled: false,
        status: 1,
        statusText: 'upcoming',
        gameState: 1,
        gameStateText: 'Not started',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        modifiedOn: '2023-01-27T12:17:00.512Z',
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d33d208d8436001e1bed90',
        createdOn: '2022-10-08T06:51:23.993Z',
        deletedOn: null,
        contestTypeId: '628747cdc76dd0419be8e2cd',
        contestCategoryId: '61817f8fb2569b001f9ddedd',
        tenant: 'dev',
        title: 'giveaway',
        description: 'giveaway',
        minimumPlayers: 100000,
        maximumPlayers: 100000,
        maxTeamPerUser: 11,
        winningsAmount: 5000000,
        entryFee: 0,
        winningsPerPosition: {
          '1100': 1000,
          '30000': 50,
          '40000': 10,
          '50000': 10,
          '100000': 1,
          '200000': 1,
          '300000': 1,
          '400000': 1,
          '500000': 1
        },
        selfReplicating: false,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 0,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        matchId: '63cda4c06bc8d3ddb9c91f39',
        isCanceled: false,
        status: 1,
        statusText: 'upcoming',
        gameState: 1,
        gameStateText: 'Not started',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        modifiedOn: '2023-01-27T12:17:00.512Z',
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d33d208d8436001e1bed92',
        createdOn: '2023-01-27T02:51:17.978Z',
        deletedOn: null,
        contestTypeId: '628747cdc76dd0419be8e2cd',
        contestCategoryId: '61817f8fb2569b001f9ddedd',
        tenant: 'dev',
        title: 'multiple',
        description: 'multiple',
        minimumPlayers: 2,
        maximumPlayers: 10,
        maxTeamPerUser: 1,
        winningsAmount: 500000,
        entryFee: 300000,
        winningsPerPosition: {
          '500000': 1
        },
        selfReplicating: true,
        bonusPercentage: 10,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 300,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        matchId: '63cda4c06bc8d3ddb9c91f39',
        isCanceled: false,
        status: 1,
        statusText: 'upcoming',
        gameState: 1,
        gameStateText: 'Not started',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        modifiedOn: '2023-01-27T12:17:00.512Z',
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d33d2b8d8436001e1beda0',
        createdOn: '2022-10-08T06:48:15.874Z',
        deletedOn: null,
        contestTypeId: '628747cdc76dd0419be8e2cd',
        contestCategoryId: '61817f8fb2569b001f9ddedd',
        tenant: 'dev',
        title: 'GL 25K',
        description: 'GL',
        minimumPlayers: 1000,
        maximumPlayers: 1000,
        maxTeamPerUser: 11,
        winningsAmount: 2500000,
        entryFee: 3000,
        winningsPerPosition: {
          '9000': 100,
          '30000': 20,
          '40000': 5,
          '50000': 2,
          '100000': 1,
          '200000': 1,
          '400000': 1
        },
        selfReplicating: false,
        bonusPercentage: 0,
        isConfirmed: true,
        isDynamicWinnings: false,
        adminFees: 500000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        matchId: '63cda4c06bc8d3ddb9c91f39',
        isCanceled: false,
        status: 1,
        statusText: 'upcoming',
        gameState: 1,
        gameStateText: 'Not started',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        modifiedOn: '2023-01-27T12:17:00.512Z',
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d33d2b8d8436001e1beda4',
        createdOn: '2023-01-27T02:51:54.145Z',
        deletedOn: null,
        contestTypeId: '628747cdc76dd0419be8e2cd',
        contestCategoryId: '61817f8fb2569b001f9ddedd',
        tenant: 'dev',
        title: 'mult2',
        description: 'mult2',
        minimumPlayers: 2,
        maximumPlayers: 10,
        maxTeamPerUser: 1,
        winningsAmount: 500000,
        entryFee: 300000,
        winningsPerPosition: {
          '500000': 1
        },
        selfReplicating: true,
        bonusPercentage: 10,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 200,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        matchId: '63cda4c06bc8d3ddb9c91f39',
        isCanceled: false,
        status: 1,
        statusText: 'upcoming',
        gameState: 1,
        gameStateText: 'Not started',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        modifiedOn: '2023-01-27T12:17:00.512Z',
        states: {
          '1': true
        },
        verified: false
      }
    ]
  },
  {
    _id: '61821e0cb2569b001f9ddf50',
    contests: [
      {
        _id: '63d35aeb8d8436001e1bedee',
        createdOn: '2023-01-27T04:57:41.157Z',
        deletedOn: null,
        contestTypeId: '628747cdc76dd0419be8e2cd',
        contestCategoryId: '61821e0cb2569b001f9ddf50',
        tenant: 'dev',
        title: 'Win More1',
        description: 'Win More',
        minimumPlayers: 100,
        maximumPlayers: 150,
        maxTeamPerUser: 8,
        winningsAmount: 10000,
        entryFee: 100,
        winningsPerPosition: {
          '3000': 1,
          '7000': 1
        },
        selfReplicating: true,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 100,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        matchId: '63cda4c06bc8d3ddb9c91f39',
        isCanceled: false,
        status: 1,
        statusText: 'upcoming',
        gameState: 1,
        gameStateText: 'Not started',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 2,
        modifiedOn: '2023-01-27T12:17:00.512Z',
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d35aeb8d8436001e1bedf0',
        createdOn: '2022-10-08T06:51:23.993Z',
        deletedOn: null,
        contestTypeId: '628747cdc76dd0419be8e2cd',
        contestCategoryId: '61821e0cb2569b001f9ddf50',
        tenant: 'dev',
        title: 'Win More4',
        description: 'Win More',
        minimumPlayers: 100000,
        maximumPlayers: 100000,
        maxTeamPerUser: 11,
        winningsAmount: 5000000,
        entryFee: 0,
        winningsPerPosition: {
          '1100': 1000,
          '30000': 50,
          '40000': 10,
          '50000': 10,
          '100000': 1,
          '200000': 1,
          '300000': 1,
          '400000': 1,
          '500000': 1
        },
        selfReplicating: false,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 0,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        matchId: '63cda4c06bc8d3ddb9c91f39',
        isCanceled: false,
        status: 1,
        statusText: 'upcoming',
        gameState: 1,
        gameStateText: 'Not started',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        modifiedOn: '2023-01-27T12:17:00.512Z',
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d35aeb8d8436001e1bedf2',
        createdOn: '2023-01-27T02:51:17.978Z',
        deletedOn: null,
        contestTypeId: '628747cdc76dd0419be8e2cd',
        contestCategoryId: '61821e0cb2569b001f9ddf50',
        tenant: 'dev',
        title: 'Win More3',
        description: 'Win More',
        minimumPlayers: 2,
        maximumPlayers: 10,
        maxTeamPerUser: 1,
        winningsAmount: 500000,
        entryFee: 300000,
        winningsPerPosition: {
          '500000': 1
        },
        selfReplicating: false,
        bonusPercentage: 10,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 300,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        matchId: '63cda4c06bc8d3ddb9c91f39',
        isCanceled: false,
        status: 1,
        statusText: 'upcoming',
        gameState: 1,
        gameStateText: 'Not started',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        modifiedOn: '2023-01-27T12:17:00.512Z',
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d35af48d8436001e1bedf4',
        createdOn: '2022-10-08T06:51:23.993Z',
        deletedOn: null,
        contestTypeId: '628747cdc76dd0419be8e2cd',
        contestCategoryId: '61821e0cb2569b001f9ddf50',
        tenant: 'dev',
        title: 'Win More4',
        description: 'Win More',
        minimumPlayers: 100000,
        maximumPlayers: 100000,
        maxTeamPerUser: 11,
        winningsAmount: 5000000,
        entryFee: 0,
        winningsPerPosition: {
          '1100': 1000,
          '30000': 50,
          '40000': 10,
          '50000': 10,
          '100000': 1,
          '200000': 1,
          '300000': 1,
          '400000': 1,
          '500000': 1
        },
        selfReplicating: false,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 0,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        matchId: '63cda4c06bc8d3ddb9c91f39',
        isCanceled: false,
        status: 1,
        statusText: 'upcoming',
        gameState: 1,
        gameStateText: 'Not started',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        modifiedOn: '2023-01-27T12:17:00.512Z',
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d35af48d8436001e1bedf6',
        createdOn: '2023-01-27T04:57:41.157Z',
        deletedOn: null,
        contestTypeId: '628747cdc76dd0419be8e2cd',
        contestCategoryId: '61821e0cb2569b001f9ddf50',
        tenant: 'dev',
        title: 'Win More1',
        description: 'Win More',
        minimumPlayers: 100,
        maximumPlayers: 150,
        maxTeamPerUser: 8,
        winningsAmount: 10000,
        entryFee: 100,
        winningsPerPosition: {
          '3000': 1,
          '7000': 1
        },
        selfReplicating: true,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 100,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        matchId: '63cda4c06bc8d3ddb9c91f39',
        isCanceled: false,
        status: 1,
        statusText: 'upcoming',
        gameState: 1,
        gameStateText: 'Not started',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        modifiedOn: '2023-01-27T12:17:00.512Z',
        states: {
          '1': true
        },
        verified: false
      }
    ]
  }
];
